import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { shopApi } from "./shopApi";

export const useNewsletterSubscriptions = (skip: number = 0, take: number = 50, enabled: boolean = true) => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.NEWSLETTER_SUBSCRIPTIONS(),
    queryFn: () => shopApi.fetchNewsletterSubscriptions(skip, take),
    enabled,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.NEWSLETTER_SUBSCRIPTIONS(),
    });
  };

  return {
    isLoading,
    isFetching,
    subscriptions: data?.data?.items ?? [],
    total: data?.data?.total ?? 0,
    invalidate,
  };
};
